import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';
import React, { useState, useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import { Tooltip } from 'src/component/Global/Tooltip';
import Helper from 'src/helper/Helper';
import Constants from 'src/helper/Constants';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useSystem } from "src/hooks/system";
import stickyTableCommon from 'src/helper/stickyTableCommon';

const OrderDetailByLineItem = () => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;

    const [{ order_detail, selected_fields }, { }, { order_download_invoice, remove_all_selected_fields, toggle_single_selected_fields }] = useOrderStore();
    const [sortBy, setSortBy] = useState('');
    const [orderbyDirection, setOrderbyDirection] = useState("asc");
    const [isReorderable] = useReduxState(false, 'setIsReOrderable')
    const [expandedRow, setExpandedRow] = useState('')
    const [sortedData, setSortedData] = useState();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { siteUser: { CORE }, speedBoats: { apacAbbr, japanAbbr } } = Constants
    const [, { get_quantity_format }] = useSystem();

    const isCoreUser = System.getCurrentRegionWithType(apacAbbr, CORE)

    useEffect(() => {
        setSortedData(order_detail?.orderItems)
    }, [order_detail])

    const sortAttributes = (columnName, direction) => {
        let Attributes = [...(order_detail?.orderItems || [])];

        const isSpecialColumn = columnName === "expectedDeliveryDate" || columnName === "deliveryOrderNum";

        const isNumericColumn = columnName === 'quantity' || columnName === 'scheduledQuantity' || columnName === 'openQuantity' || columnName === 'unitPrice' || columnName === 'totalPrice';
        const isSpecialAndNumeric = columnName === "deliveryQuantity"

        const dir = direction === 'asc' ? 1 : -1;

        const AttributesSorted = Attributes.sort((a, b) => {
            let valA, valB;
            if (isSpecialColumn) {
                valA = (a?.processedDetails?.length ? a?.processedDetails?.[0][columnName] : "")?.toString()?.toLowerCase();
                valB = (b?.processedDetails?.length ? b?.processedDetails?.[0][columnName] : "")?.toString()?.toLowerCase();
            } else if (isSpecialAndNumeric) {
                valA = a?.processedDetails?.length ? Number(a?.processedDetails?.[0][columnName]) : 0;
                valB = b?.processedDetails?.length ? Number(b?.processedDetails?.[0][columnName]) : 0;
            } else if (isNumericColumn) {
                valA = Number(a[columnName]) || 0;
                valB = Number(b[columnName]) || 0;
            } else {
                valA = (a[columnName] || "")?.toString()?.toLowerCase();
                valB = (b[columnName] || "")?.toString()?.toLowerCase();
            }

            if (valA < valB) return -1 * dir;
            if (valA > valB) return 1 * dir;
            return 0;
        });

        setSortedData(AttributesSorted);
    };

    const onToggleSelect = (values) => {
        let selectedField = { ...values }
        toggle_single_selected_fields({ ...selectedField, type: 'byItem' })
    }

    const handleClick = async (shipment) => {
        setExpandedRow(prevExpandedRow => prevExpandedRow === shipment ? null : shipment);
    }

    const renderLegendIcon = (iconPath, message, showIcon) => {
        return (
            showIcon ?
                (
                    <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={iconPath} /></span>
                ) :
                (
                    <Tooltip
                        position={'bottom left'}
                        opener={() => (
                            <span className="list-text-icon"><img
                                className="img-fluid me-1" alt="Legend Information Icon"
                                src={iconPath} /></span>
                        )}
                        content={() => (
                            message
                        )}
                    />
                )
        )
    };

    const getStatusOfForFieldActivated = (selectedList) => {
        if (selected_fields && selected_fields[selectedList.uniqueNumber] !== undefined) {
            return selected_fields[selectedList.uniqueNumber];
        }

        return false
    };

    const downloadInvoice = async (invoiceNumber, orderNumber = 0) => {
        if (System.getCurrentRegionWithType(japanAbbr)) {
            System.popup('OrderJapanInvoicePopup', {
                orderNumber: orderNumber,
                invoiceNumber: invoiceNumber
            })
        } else {
            const result = await order_download_invoice(invoiceNumber);
            if (result) {
                system_alert_indicator({
                    name: 'DownloadOrder',
                    message: t('downloadMsg'),
                    type: "success"
                })
            }
        }
    }

    const displayTrackingNumber = (number, carrier) => {
        let carrierLink = ''

        if (carrier && System.getCurrentRegionWithType(japanAbbr)) {
            const carrierMethod = carrier?.split('|')[1] || ''
            carrierLink = carrierMethod !== '' ? System.getTrackingLink(carrierMethod) : ''
        }

        return carrierLink !== '' ? <a href={carrierLink} target='_blank'><span className='text-blue'>{number}</span></a> :
            <span className='text-black'>{number}</span>
    }

    const renderOrderItem = (j, processItem) => {
        return <>
            <td>
                <div className="accordian-arrow">
                    <i
                        className={expandedRow === j.lineItemNumber ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                        onClick={() => handleClick(j.lineItemNumber)}
                    />
                </div>
            </td>
            <td>
                {(isReorderable) &&
                    <div className="form-check d-flex align-items-center font-15 ps-0">
                        <input type="checkbox" className="form-check-input ms-0"
                            id="forCheckbox"
                            onChange={() => (onToggleSelect(j))}
                            checked={getStatusOfForFieldActivated(j)}
                            disabled={(isReorderable && !j.isReorder)}
                        />
                        <label className="form-check-label" htmlFor="forCheckbox" />
                    </div>
                }
            </td>
            {isCoreUser && <td>
                <div>
                    <a href={void (0)} className="text-blue2 d-flex align-items-center"
                        onClick={() => System.popup('OrderHistoryEmailPopUp', {
                            singleOrder: {
                                orderDate: order_detail?.orderHeader?.orderCreationType === 'Online' ? Helper.orderHistoryDateFormat(order_detail?.orderHeader?.frontendOrderCreatedOn) : Helper.orderHistoryDateFormat(order_detail?.orderHeader?.backendOrderCreatedOn),
                                poNumber: order_detail?.orderHeader?.poNumber,
                                webOrderNum: order_detail?.orderHeader?.webOrderNumber,
                                salesOrderNum: order_detail?.orderHeader?.salesOrderNumber,
                                azureOrderNum: order_detail?.orderHeader?.azureOrderNum,
                                smrEmail: order_detail?.smrEmail
                            },
                            singleProduct: {
                                parentManufacturerName: j?.parentManufacturerName,
                                mfrPartNumber: j?.erpmfrPartNumber,
                                custMatNum: j?.customerPartNumber,
                                qty: j?.quantity
                            },
                            isFrom: Constants.systemModules.ORDERDETAIL
                        })}>
                        <i className="fa fa-envelope font-16"></i>
                    </a>
                </div>
            </td>}
            <td>
                <div>{j.lineItemNumber}</div>
            </td>
            <td><div>{j.parentManufacturerName}</div></td>
            <td>
                {j?.seoItemnumber ?
                    Number(j.published) !== 0 ?
                        <NavigateToProductDetail
                            target="_blank"
                            data={{ ManufacturerName: j?.parentManufacturerName, ERPMFRPartNumber: j?.erpmfrPartNumber, ItemNumber: j?.itemNumber, ERPPartNumber: j?.sapMaterial, seoItemNumber: j?.seoItemnumber }}>
                            <span className="text-nowrap text-blue2">{j.erpmfrPartNumber ? j.erpmfrPartNumber : ''}</span>
                        </NavigateToProductDetail>
                        :
                        <span className="text-nowrap ">{j?.erpmfrPartNumber || j?.manufacturPartNumber || j?.sapMaterial}</span>
                    :
                    <span className="text-nowrap">{j?.erpmfrPartNumber || j?.manufacturPartNumber || j?.sapMaterial}</span>
                }
                <p className='mb-0'>{j.manufacturePartDescription ? j.manufacturePartDescription : ''}</p>
            </td>
            {isCoreUser && <td><span className="text-nowrap">{j.customerPartNumber && j.customerPartNumber}</span></td>}
            <td><span className="text-nowrap">{j.lineStatus && j.lineStatus}</span></td>
            <td><span className="text-nowrap">{j.quantity && get_quantity_format(j.quantity)}</span></td>
            <td><span className="text-nowrap">{j.unitPrice && System.getFormatNumber({ amount: Number(j.unitPrice), currency: System.getRegionCurrency() })}</span></td>
            <td><span className="text-nowrap">{j.totalPrice && System.getFormatNumber({ amount: Number(j.totalPrice), currency: System.getRegionCurrency(), roundOff: true, maximumFractionDigits: 2 })}</span></td>
            {System.getCurrentRegionWithType(apacAbbr) && <td><span className="text-nowrap">{j.openQuantity && get_quantity_format(j.openQuantity)}</span></td>}
            {isCoreUser && <td><div className="text-nowrap">{j.customerRequestedDate ? Helper.orderHistoryDateFormat(j.customerRequestedDate) : ""}</div></td>}
            {isCoreUser && <td><div className="text-nowrap">{j.scheduledQuantity ? get_quantity_format(j.scheduledQuantity) : ""}</div></td>}
            {!processItem && <><td></td><td></td><td></td></>}
            {!processItem && System.getCurrentRegionWithType(apacAbbr) && <td></td>}
            {!processItem && <td className="text-nowrap"><span className="text-nowrap">{j.ncnr ? renderLegendIcon(noncancel, 'Non-Cancelable, Non-Returnable', false) : ""}</span></td>}
        </>
    }

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName) {
            return 'sorting sorting_' + orderbyDirection;
        }
        return 'sorting';
    };

    const toggleOrderBy = (columnName) => {
        if (sortBy === columnName) {
            setOrderbyDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortBy(columnName);
            setOrderbyDirection('asc');
        }
    };

    useEffect(() => {
        if (sortBy) {
            sortAttributes(sortBy, orderbyDirection);

        }
    }, [sortBy, orderbyDirection, order_detail]);

    useEffect(() => {
        if (sortedData?.length > 0) {
            stickyTableCommon('order-detail-table', toggleOrderBy);
            window.scrollTo({ top: 0 });
        }
    }, [sortedData, __check(['GET_ORDER_DETAIL']).status]);

    return (
        <>
            {__check(['GET_ORDER_DETAIL']).render}
            <div className="position-relative">
                <div id="sticky-table-wrapper" className='floating-table table-responsive orderdetailbylineitem'>
                    {order_detail?.orderItems?.length > 0 && !__check(['GET_ORDER_DETAIL']).status &&
                        <table id="order-detail-table" className="bs5 table table-bordered " >
                            <thead>
                                <tr>
                                    <th> </th>
                                    <th></th>
                                    {isCoreUser && <th className=""></th>}
                                    <th>
                                        <span aria-label="lineItem">{t('lineItem')} {!System.getCurrentRegionWithType(japanAbbr) && <><br />{t('number')} </>}</span>
                                    </th>
                                    <th>
                                        <span>{t('manufacturer')}</span>
                                        <span aria-label="parentManufacturerName" className={'sort-container ' + getOrderByClass("parentManufacturerName")}
                                            onClick={() => toggleOrderBy("parentManufacturerName")}
                                        ></span>
                                    </th>
                                    <th>
                                        <span>{System.getCurrentRegionWithType(apacAbbr) ? <>{t('manufacturerPart')}<br />{t('number')}</> : t('manufacturerPartNumber')}</span>
                                        <span aria-label="erpmfrPartNumber"
                                            className={'sort-container ' + getOrderByClass("erpmfrPartNumber")}
                                            onClick={() => toggleOrderBy("erpmfrPartNumber")}
                                        ></span>
                                    </th>
                                    {isCoreUser &&
                                        <th>
                                            <span>{t('customerPart')} <br />{t('number')}</span>
                                            <span aria-label="customerPartNumber"
                                                className={'sort-container ' + getOrderByClass("customerPartNumber")}
                                                onClick={() => toggleOrderBy("customerPartNumber")}
                                            ></span>
                                        </th>
                                    }

                                    <th>
                                        <span>{t('lineStatus')}</span>
                                        <span aria-label="lineStatus"
                                            className={'sort-container ' + getOrderByClass("lineStatus")}
                                            onClick={() => toggleOrderBy("lineStatus")}
                                        ></span>
                                    </th>

                                    <th>
                                        <span>{t('quantity')}</span>
                                        <span aria-label="quantity"
                                            className={'sort-container ' + getOrderByClass("quantity")}
                                            onClick={() => toggleOrderBy("quantity")}
                                        ></span>
                                    </th>
                                    <th>
                                        <span>{t('unitPrice')}</span>
                                        <span aria-label="unitPrice"
                                            className={'sort-container ' + getOrderByClass("unitPrice")}
                                            onClick={() => toggleOrderBy("unitPrice")}
                                        ></span>
                                    </th>
                                    <th>
                                        <span>{t('totalPrice')}</span>
                                        <span aria-label="totalPrice"
                                            className={'sort-container ' + getOrderByClass("totalPrice")}
                                            onClick={() => toggleOrderBy("totalPrice")}
                                        ></span>
                                    </th>
                                    {System.getCurrentRegionWithType(apacAbbr) && <th>
                                        <span>{t('openQuantity')}</span>
                                        <span aria-label="openQuantity"
                                            className={'sort-container ' + getOrderByClass("openQuantity")}
                                            onClick={() => toggleOrderBy("openQuantity")}
                                        ></span>
                                    </th>}
                                    {isCoreUser &&
                                        <th>
                                            <span>{t('customer')} <br />{t('requestedDate')}</span>
                                            <span aria-label="customerRequestedDate"
                                                className={'sort-container ' + getOrderByClass("customerRequestedDate")}
                                                onClick={() => toggleOrderBy("customerRequestedDate")}
                                            ></span>
                                        </th>
                                    }
                                    {isCoreUser &&
                                        <th>
                                            <span>{t('scheduled')} <br />{t('quantity')}</span>
                                            <span aria-label="scheduledQuantity"
                                                className={'sort-container ' + getOrderByClass("scheduledQuantity")}
                                                onClick={() => toggleOrderBy("scheduledQuantity")}
                                            ></span>
                                        </th>
                                    }
                                    <th>
                                        <span>{t('expected')} <br />{t('deliveryDate')}</span>
                                        <span aria-label="expectedDeliveryDate"
                                            className={'sort-container ' + getOrderByClass("expectedDeliveryDate")}
                                            onClick={() => toggleOrderBy("expectedDeliveryDate")}
                                        ></span>
                                    </th>
                                    <th>
                                        <span>{t('delivery')} <br />{t('quantity')}</span>
                                        <span aria-label="deliveryQuantity"
                                            className={'sort-container ' + getOrderByClass("deliveryQuantity")}
                                            onClick={() => toggleOrderBy("deliveryQuantity")}
                                        ></span>
                                    </th>
                                    <th>
                                        <span>{System.getCurrentRegionWithType(apacAbbr)
                                            ? <>
                                                {t('deliveryOrder')}<br />
                                                {t('number')}
                                            </>
                                            : t('doNumber')
                                        }</span>
                                    </th>
                                    <th>
                                        <span>{t('information')}</span>
                                        <span aria-label="ncnr"
                                            className={'sort-container ' + getOrderByClass("ncnr")}
                                            onClick={() => toggleOrderBy("ncnr")}
                                        ></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedData?.map((j, i) => (
                                    <React.Fragment key={i}>
                                        {j.processedDetails?.length <= 0 ? <tr className={`align-middle ${expandedRow && expandedRow === j.lineItemNumber ? 'bg-offwhite' : ''} ${(isReorderable && !j.isReorder) && 'disabled'}`} key={i + 1}>{renderOrderItem(j)}</tr> :
                                            j.processedDetails.map((processItem, index) => {
                                                return <tr className={`align-middle ${(isReorderable && !j.isReorder) && 'disabled'}`} key={index} style={{ border: 'none' }}>
                                                    {index === 0 ? renderOrderItem(j, processItem) : <>
                                                        <td />
                                                        <td />
                                                        <td />
                                                        {isCoreUser && <td />}
                                                        <td />
                                                        <td />
                                                        <td />
                                                        {isCoreUser && <td />}
                                                        <td />
                                                        <td />
                                                        <td />
                                                        {System.getCurrentRegionWithType(apacAbbr) &&
                                                            <td />
                                                        }
                                                        {isCoreUser && <td />}
                                                        {isCoreUser && <td />}
                                                    </>}

                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td><span className="text-nowrap">{processItem.expectedDeliveryDate ? Helper.orderHistoryDateFormat(processItem.expectedDeliveryDate) : ""}</span></td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td><span className="text-nowrap">{processItem.deliveryQuantity ? get_quantity_format(processItem.deliveryQuantity) : ""}</span></td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td><table>
                                                        <tr>
                                                            <td><span className="text-nowrap">{processItem.deliveryOrderNum ? processItem.deliveryOrderNum : ""}</span></td>
                                                        </tr>
                                                    </table>
                                                    </td>
                                                    <td><span className="text-nowrap">{j.ncnr ? renderLegendIcon(noncancel, 'Non-Cancelable, Non-Returnable', false) : ""}</span></td>
                                                </tr>
                                            })}
                                        <tr className={`align-middle ${expandedRow && expandedRow === j.lineItemNumber ? 'bg-offwhite' : ''} ${(isReorderable && !j.isReorder) && 'disabled'}`} key={i + 2}>
                                        </tr>
                                        <tr className={`align-middle bg-offwhite ${(isReorderable && !j.isReorder) && 'disabled'}`}>
                                            <td colSpan={19} className='p-0'>
                                                <div className={expandedRow === j.lineItemNumber ? "table-responsive mb-0" : "table-responsive mb-0 d-none"}>
                                                    <table className="bs5 table table-head-border-x-0 mb-4">
                                                        <thead>
                                                            <tr>
                                                                <th className="w40 border-0 bg-offwhite"></th>
                                                                <th className="w40 border-0 bg-offwhite"></th>
                                                                <th className="w40 border-0 bg-offwhite"></th>
                                                                <th className="w150"><span>{t('shippedQuantity')}</span></th>
                                                                <th className="w150"><span>{t('shippedOnDate')}</span></th>
                                                                {isCoreUser && <th className="w150"><span>{t('customer')} <br />{t('requestedDate')}</span></th>}
                                                                <th className="w150"><span>{t('expected')} <br />{t('deliveryDate')}</span></th>
                                                                <th className="w150"><span>{t('doNumber')}</span></th>
                                                                <th className="w150"><span>{t('trackingNumber')}</span></th>
                                                                <th className=""><span>{t('invoiceNumber')}</span></th>
                                                            </tr>
                                                        </thead>
                                                        {j.processedDetails?.length > 0 &&
                                                            <>
                                                                <tbody>
                                                                    {j.processedDetails?.map((val, index) => (
                                                                        <tr className={`align-middle ${(isReorderable && !j.isReorder) && 'disabled'}`} key={index}>
                                                                            <td className='border-0'></td>
                                                                            <td className='border-0'></td>
                                                                            <td className='border-0'></td>
                                                                            <td><div>{get_quantity_format(val.deliveryQuantity)}</div></td>
                                                                            <td><div>{val.shippedDate ? Helper.orderHistoryDateFormat(val.shippedDate) : ""}</div></td>
                                                                            {isCoreUser && <td><div>{j.customerRequestedDate ? Helper.orderHistoryDateFormat(j.customerRequestedDate) : ""}</div></td>}
                                                                            <td><div>{val.expectedDeliveryDate ? Helper.orderHistoryDateFormat(val.expectedDeliveryDate) : ""}</div></td>
                                                                            <td>{val.deliveryOrderNum}</td>
                                                                            <td>{displayTrackingNumber(val.shippingTrackingNum, order_detail?.orderHeader?.shippingMethod)}</td>
                                                                            <td>
                                                                                <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                                    onClick={() => downloadInvoice([val.invoiceNumber], order_detail?.orderHeader?.webOrderNumber)}>
                                                                                    {val.invoiceNumber}
                                                                                </a>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </>}
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>
            </div>
            <div class="pagination-row">
            </div>
        </>
    )
}

export default OrderDetailByLineItem